<template>
  <div class="wlx-site-activity-detail-wrapper">
    <div class="site-activity-detail-content">
      <h4 class="ac-detail-h4">{{acvitityDetail.Title}}</h4>
      <p class="p-detail-time">
          <span>发布时间：</span>{{acvitityDetail.PulishTime}}</p>
      <div v-html="acvitityDetail.Content" class="ac-detail-content"></div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
      return {
         acvitityDetail:{}
      }
  },
  props: {
    id: {
      type: String,
      default: ""
    },
  },
  created(){
      this.getAttestationInfo();
  },
  methods: {
    //获取活动详情
    getAttestationInfo(){
      var that = this;
      this.$http.post(
        '/api/XOrg/AttestationActivity/getAttestationInfo',
        {
          Id: that.id
        }
      )
      .then(rst =>{
        if(rst.code ==1){
          that.acvitityDetail= rst.attestationInfo
        }else {
          that.$message.warning(rst.msg);
        }
      });
    },
  }
};
</script>

<style lang="scss">
.wlx-site-activity-detail-wrapper {
  .site-activity-detail-content {
    margin: 0 auto;
    padding: 20px 55px;
    width: 1200px;
    box-sizing: border-box;
    .ac-detail-h4 {
      text-align: center;
      color: #333333;
      font-size: 20px;
      font-weight: normal;
    }
    .p-detail-time {
      margin-top: 19px;
      text-align: center;
      color: #999999;
      font-size: 14px;
    }
    .ac-detail-content {
      font-size: 14px;
      p {
        color: #333333;
        font-size: 14px;
      }
      img {
        display: block;
        margin: 20px auto 0;
        max-width: 80%;
      }
    }
  }
}
</style>
